<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add Funny</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/funnies" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createFunny" v-if="funny">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-12">
                                <fg-input type="text"
                                          v-model="funny.funnyName"
                                          label="Title"
                                          placeholder="Enter Funny Title"
                                          v-validate="rules.funnyName"
                                          data-vv-name="Title"
                                          cus-name="Title"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="funny.funnyUrl"
                                      label="Image URL"
                                      placeholder="Enter Image URL"
                                      v-validate="rules.funnyUrl"
                                      data-vv-name="Image URL"
                                      cus-name="Image URL"
                                      :has-errors="errors"
                                      :is-fields="fields"
                                      >
                            </fg-input>
                          </div>
                          <div class="col-12" v-if="corps.length">
                            <multiselect
                              v-model="funny.csvCorporationId"
                              placeholder="Select Corporation"
                              :multiple="true"
                              :taggable="true"
                              :options="corps.map(type => type.corporationId)"
                              :custom-label="opt => corps.find(x => x.corporationId == opt).name"
                              required>
                              >
                            </multiselect>
                          </div>
                            <div class="col-3" v-if="status.length">
                              <fg-select
                                v-model="funny.active"
                                label="isActive"
                                v-validate="rules.active"
                                data-vv-name="active"
                                cus-name="active"
                                :has-errors="errors"
                                :is-fields="fields"
                                :list="status"
                                selectedKey="id"
                              >
                              </fg-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Funny
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateFunny',
    data () {
        return {
            funny: {
                funnyName: '',
                funnyUrl: '',
                active: '1',
              csvCorporationId: null,
            },
            corps: [],
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            rules: {
              funnyName: {required : true},
              funnyUrl: {required : true},
              active: {required: true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        createFunny () {
          console.log("this.funny : ", this.funny);
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_FUNNY', this.funny)
                .then((res) => {
                  console.log("ADD_FUNNY res : ", res);
                  if(res) this.showPopup('Success!', 'Funny is successfully created', 'success', ()=>this.$router.push('/admin/funnies'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_FUNNY API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {
    this.fetchCorporations();
    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Funnies/CreateFunny.vue